import type {
  LanguageSwitchLinkFragment,
  ProductRouteQuery,
} from '#graphql-operations'

// @TODO: Probably not needed anymore.
export function setLanguageLinksFromFragment(
  _links: LanguageSwitchLinkFragment[],
) {
  // Intentionally empty: kept for call-site compatibility.
}

export function setLanguageLinksFromRoute(
  query?: ProductRouteQuery | undefined | null,
) {
  if (query && query.route && 'languageSwitchLinks' in query.route) {
    setLanguageLinksFromFragment(query.route.languageSwitchLinks)
  }
}
